var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-auto-complete',_vm._b({attrs:{"value":_vm.value,"dataSource":_vm.dataSource},on:{"select":_vm.emit,"focus":_vm.onSearch,"search":_vm.onSearch}},'a-auto-complete',_vm.autoCompleteProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }